import React from "react";
import classes from "./Header.module.css";
import { IpropsHeader } from "../../interfaces/props/IpropsHeader/IpropsHeader";
import { NotificationsDrawer } from "../Notifications/NotificationsDropDown/NotificationsDrawer";
import { Badge, Dropdown } from "antd";
import {
  BellOutlined,
  LogoutOutlined,
  PieChartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MenuItemType } from "../../types/MenuItemType";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import { LOGOUT_USER } from "../../store/slice/authSliceLogin/authSliceLogin";
import { useGetPermissionQuery } from "../../store/api/permission.api";
import { USER } from "../../types/indexTypeEnum";
import { SELECT_PROFILE_ROLE } from "../../store/selectors/profileSelectors";
import { getFullName } from "../../utils/utilities/getFullNameStringFromObject";
import { formatPhoneNumberEightStart } from "../../utils/utilities/formatPhoneNumber";

export const HeaderMain = (props: IpropsHeader) => {
  const dispatch = useAppDispatch();
  const {
    className,
    activeMenu,
    resetActiveMenu,
    countNotification,
    openBellOut,
    openNotification,
    closeNotificatrions,
    openUserPage,
  } = props;

  const { data: permissionData } = useGetPermissionQuery(undefined);

  const userInfo = permissionData?.data.user;
  const userRole = useAppSelector(SELECT_PROFILE_ROLE);

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItemType[],
  ): MenuItemType {
    return {
      key,
      icon,
      children,
      label,
    } as MenuItemType;
  }
  const referralManagerInfo = permissionData?.data.info_manager;
  const userRoleType = userInfo?.type;

  const userName = userInfo
    ? `${userInfo.surname} ${userInfo.name[0] || ""}${userInfo.patronymic ? `.${userInfo.patronymic[0]}` : ""} `
    : "";

  const mainUserInfo: Record<string, React.ReactNode> = {
    [USER.AGENT_SIMPLE]: userName || "",
    [USER.CLIENT_SIMPLE]: userName || "",
    [USER.MANAGER]: userName || "",
    [USER.SUPPORT_ADMIN]: "Администратор",
    [USER.SUPPORT_CREDIT]: "Кредитный специалист",
  };

  const refManagerString =
    referralManagerInfo &&
    `Ваш менеджер: ${getFullName(referralManagerInfo)} ${formatPhoneNumberEightStart(referralManagerInfo?.phone_number || "")}`;
  return (
    <header className={`${className} ${classes.header}`}>
      <div className={classes.icons}>
        <div className={classes.headerNotification}>
          <Badge style={{ top: -5 }} count={countNotification}>
            <BellOutlined
              data-cy={"button-layout-header-icon-notifications-drawer"}
              className={`
                  ${classes.icon}
                  ${activeMenu === "bellOut" ? classes.activeIcon : ""}
                `}
              onClick={openBellOut}
            />
          </Badge>
        </div>
        {openNotification && (
          <NotificationsDrawer
            active={openNotification}
            close={closeNotificatrions}
            resetActiveMenu={resetActiveMenu}
          />
        )}

        <Dropdown
          menu={{
            items: [
              ![USER.SUPPORT_CREDIT, USER.SUPPORT_ADMIN].includes(userRole)
                ? getItem(
                    <Link
                      data-cy={"link-layout-header-icon-profile"}
                      to={"/profile"}
                      onClick={openUserPage}
                    >
                      Профиль
                    </Link>,
                    "1",
                    <PieChartOutlined onClick={openUserPage} />,
                  )
                : null,
              getItem(
                <a
                  data-cy={"link-layout-header-icon-logout"}
                  onClick={() => dispatch(LOGOUT_USER())}
                >
                  Выход
                </a>,
                "2",
                <LogoutOutlined onClick={() => dispatch(LOGOUT_USER())} />,
              ),
            ],
          }}
          placement="bottom"
          arrow
        >
          <UserOutlined
            className={classes.icon}
            onClick={(e) => e.preventDefault()}
          />
        </Dropdown>
      </div>

      {referralManagerInfo && (
        <div className={classes.headerItem}>
          <div className={classes.headerItemTitle}>{refManagerString}</div>
        </div>
      )}

      {userRoleType && (
        <div className={classes.headerItem}>{mainUserInfo[userRoleType]}</div>
      )}
    </header>
  );
};

export default HeaderMain;
